import {Box} from '@mui/material';
import Paper from '@mui/material/Paper';
import * as React from 'react';
import {useState} from 'react';
import {withCommentContext} from '../actuality/context/commentContext';
import {withLikeCountContext} from '../actuality/context/likeCountContext';
import {withLikeStatusContext} from '../actuality/context/likeStatusContext';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import ActualityExpandLess from './ActualityExpandLess';
import ActualityExpandMore from './ActualityExpandMore';
import './actuality.less';

const ActualityCard = ({actuality, header, token, showCommunityInfo,id}) => {
  const [expandMore, setExpandMore] = useState(false);
  const handleToggleClick = () => {
    setExpandMore(!expandMore);
  };
  const {mode} = useDarkMode();
  return (
    <Paper
      sx={{
        p: 2,
        margin: 'auto',
        flexGrow: 1,
        boxShadow: '4px 3px 8px 1px #9696966b',
        marginBottom: 3,
      }}
      style={{backgroundColor: mode.settings.cardBackgroundColor}}
	  id={id}	>
      <Box>
        {expandMore ? (
          <ActualityExpandMore
            actuality={actuality}
            expandMore={expandMore}
            handleToggleClick={handleToggleClick}
            showCommunityInfo={showCommunityInfo}
          />
        ) : (
          <ActualityExpandLess
            actuality={actuality}
            expandMore={expandMore}
            handleToggleClick={handleToggleClick}
            showCommunityInfo={showCommunityInfo}
          />
        )}
      </Box>
    </Paper>
  );
};

export default withLikeCountContext(
  withLikeStatusContext(withCommentContext(ActualityCard)),
);
